(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/video-analysis-player/assets/javascripts/use-video-loader.js') >= 0) return;  svs.modules.push('/components/tipsen/video-analysis-player/assets/javascripts/use-video-loader.js');
"use strict";


const {
  useEffect,
  useMemo,
  useRef,
  useState
} = React;
const loadVideo = svs.components.video_player.contentLoader.loadVideo;
const {
  updatePlaybackState
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions;
const VIDEO_CLEAR_DELAY = 500;
const createInitialPlaybackState = () => ({
  isPlaying: false,
  isReady: false,
  currentPosition: 0,
  duration: 0
});

const useVideoLoader = (currentVideo, dispatch) => {
  const [loadedVideo, setLoadedVideo] = useState(null);
  const [hasError, setHasError] = useState(false);
  const currentVideoRef = useRef(currentVideo);

  useEffect(() => {
    currentVideoRef.current = currentVideo;
  }, [currentVideo]);

  const playerSettings = useMemo(() => {
    if (!(currentVideo !== null && currentVideo !== void 0 && currentVideo.id)) {
      return null;
    }
    return {
      api: true,
      publishedAt: currentVideo.publishedAt,
      thumbnail: currentVideo.thumbnailUrl,
      title: currentVideo.title,
      type: 'solidtango',
      videoId: currentVideo.id
    };
  }, [currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.publishedAt, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.thumbnailUrl, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title]);

  useEffect(() => {
    let clearTimeoutId = null;
    if (!(currentVideo !== null && currentVideo !== void 0 && currentVideo.id)) {
      setHasError(false);
      dispatch(updatePlaybackState(createInitialPlaybackState()));

      setLoadedVideo(prevLoadedVideo => {
        if (prevLoadedVideo) {
          clearTimeoutId = setTimeout(() => {
            setLoadedVideo(null);
          }, VIDEO_CLEAR_DELAY);
        }
        return prevLoadedVideo; 
      });
      return () => {
        if (clearTimeoutId) {
          clearTimeout(clearTimeoutId);
        }
      };
    }
    if (!playerSettings) {
      return;
    }
    setHasError(false);
    setLoadedVideo(null);
    loadVideo(playerSettings, (err, model) => {
      var _currentVideoRef$curr;
      if (((_currentVideoRef$curr = currentVideoRef.current) === null || _currentVideoRef$curr === void 0 ? void 0 : _currentVideoRef$curr.id) === currentVideo.id) {
        if (err) {
          setHasError(true);
          return;
        }
        setLoadedVideo(model);
      }
    });
    return () => {
      if (clearTimeoutId) {
        clearTimeout(clearTimeoutId);
      }
    };
  }, [currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id, playerSettings, dispatch]);
  return {
    loadedVideo,
    hasError,
    currentVideoRef
  };
};
setGlobal('svs.components.tipsen.videoAnalysisPlayer', {
  createInitialPlaybackState,
  useVideoLoader
});

 })(window);